import { apiConstants, getGeneric } from "../../common/constants";

// Statuses and categories are global, admin-edited config that rarely changes, so the list page
// and Create Ticket share one request per endpoint for the session instead of refetching on every
// mount and every Create Ticket open. Entries expire after TTL_MS; a failed request is dropped so
// the next caller retries.
const TTL_MS = 30 * 60 * 1000;
const cache = {};

const cachedGet = (endpoint) => {
    const hit = cache[endpoint];
    if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
    const promise = getGeneric(endpoint).then((response) => response?.data || []);
    promise.catch(() => { if (cache[endpoint]?.promise === promise) delete cache[endpoint]; });
    cache[endpoint] = { promise, at: Date.now() };
    return promise;
};

export const getStatusConfig = () => cachedGet(apiConstants.ESCALATION_STATUS_CONFIG_V2);
export const getCategoryConfig = () => cachedGet(apiConstants.ESCALATION_CATEGORY_CONFIG_V2);
